import * as mobx from 'mobx';
import { observable, action } from 'mobx';

export default class FollowSelectStore{
        //关注点击按钮的位置
        @observable clickPotion={};
        @observable followTypeSelectShow = false;
        @observable FollowRequestid='';
        @action
        setClickPotion(params) {
            this.clickPotion = params;
        }
        
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/followSelect.js